var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxsGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23669 15H5.98669V25C5.98669 25.663 6.25009 26.2989 6.71893 26.7678C7.18777 27.2366 7.82365 27.5 8.48669 27.5H14.7367V15H7.23669ZM23.4867 15H17.2367V27.5H23.4867C24.1497 27.5 24.7856 27.2366 25.2545 26.7678C25.7233 26.2989 25.9867 25.663 25.9867 25V15H23.4867ZM24.4754 8.75C24.6588 8.14223 24.7469 7.50974 24.7367 6.875C24.7367 4.4625 22.7742 2.5 20.3617 2.5C18.3342 2.5 16.9804 4.3525 16.1067 6.35625C15.2454 4.4625 13.8229 2.5 11.6117 2.5C9.19919 2.5 7.23669 4.4625 7.23669 6.875C7.23669 7.62 7.33544 8.23625 7.49794 8.75H3.48669V13.75H14.7367V11.25H17.2367V13.75H28.4867V8.75H24.4754ZM9.73669 6.875C9.73669 5.84125 10.5779 5 11.6117 5C12.7217 5 13.7542 6.90625 14.3592 8.75H10.9867C10.5192 8.75 9.73669 8.75 9.73669 6.875ZM20.3617 5C21.3954 5 22.2367 5.84125 22.2367 6.875C22.2367 8.75 21.4542 8.75 20.9867 8.75H17.8904C18.5279 6.78 19.4542 5 20.3617 5Z",
    fill: "url(#paint0_linear_1_1554)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1554",
    x1: 15.9867,
    y1: 2.5,
    x2: 15.9867,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027E8A",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsGift);
export default __webpack_public_path__ + "static/media/bxs-gift.2b10d0c7d0f3cb19098a27182db07cf1.svg";
export { ForwardRef as ReactComponent };